import { Component } from 'react';
import { ChipSet as MDCChipSet } from '@material/react-chips';
import PropTypes from 'prop-types';

class ChipSet extends Component {
	state = {
		selectedChipIds: [],
	};

	handleSelect = selectedChipIds => {
		this.setState({ selectedChipIds });
		if (this.props.handleSelect) {
			this.props.handleSelect(selectedChipIds);
		}
	};

	render() {
		return (
			<MDCChipSet {...this.props} handleSelect={this.handleSelect}>
				{this.props.children}
			</MDCChipSet>
		);
	}
}

// documentation: https://github.com/material-components/material-components-web-react/tree/master/packages/chips#chip-set
ChipSet.propTypes = {
	choice: PropTypes.bool,
	className: PropTypes.string,
	filter: PropTypes.bool,
	handleSelect: PropTypes.func,
	input: PropTypes.bool,
	selectedChipIds: PropTypes.array,
	updateChips: PropTypes.func,
};

export default ChipSet;
